import { Suspense } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/ScrollToTop";
import Chatbot from "./components/Chatbot";
import SeoRouteBridge from "./components/seo/SeoRouteBridge";
import { useMounted } from "./hooks/use-mounted";

// No router here: main.tsx wraps App in BrowserRouter, entry-server.tsx in StaticRouter.
function App() {
  // The chatbot is browser-only UI (reCAPTCHA, scrolling, timestamps): mount it after
  // hydration so the prerendered HTML and the first client render match.
  const mounted = useMounted();
  return (
    <I18nextProvider i18n={i18n}>
      <SeoRouteBridge />
      <ScrollToTop />
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-gray-700 font-medium">Loading...</p>
          </div>
        </div>
      }>
        <AppRoutes />
      </Suspense>
      {mounted && <Chatbot />}
    </I18nextProvider>
  );
}

export default App;
